
import Entities from './Entities'

export default ({ getDomains, addDomain, removeDomain }) ->
  Entities({
    addEntity: addDomain
    allEntities: Weaver.Domain.list
    entityFilter: (value, role) ->
      role.name().toLowerCase().includes(value.toLowerCase())
    comparator: (domain) -> domain.id()
    sortBy: (domain) -> domain.name()
    getEntities: getDomains
    removeEntity: removeDomain
    title: 'domains'
    titleRenderer: (item) -> item.name()
  })
